/** Resolve Nest BadRequest-style exception keys like `exceptions.missingRateForCurrency: KPW`. */
export function resolveExceptionMessage(error, t, fallback) {
  var raw = typeof error === 'string' ? error : error === null || error === void 0 ? void 0 : error.message;
  if (!raw) return fallback;
  var value = String(raw);
  var index = value.indexOf(':');
  var key = (index === -1 ? value : value.slice(0, index)).trim();
  var currency = index === -1 ? undefined : value.slice(index + 1).trim();
  if (/^exceptions\.\w+$/.test(key)) {
    return String(t("translation:".concat(key), {
      currency: currency,
      defaultValue: currency ? "".concat(fallback, " (").concat(currency, ")") : fallback
    }));
  }
  return String(t(raw, {
    defaultValue: raw
  }));
}